import { Box, IconButton } from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { useTranslation } from 'react-i18next';
import { color } from 'theme';
import IconCalendarDatePicker from '../DateRangePickerCC/IconCalendar';
import './DatePickerCC.css';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentDay } from 'pages/manager-meeting/managerMeetingSlice';
import { CALENDAR_VIEW, SLICE_NAME } from 'constants/common';
import dayjs from 'dayjs';

const DatePickerCalenderCC = ({ maxDate = false, setDiffTime, handleChangeTimeInCalendar }) => {
    const { t } = useTranslation()
    const inputDatePickerCCRef = useRef(null)
    const dispatch = useDispatch()
    const { currentDay } = useSelector(state => state[SLICE_NAME.MANAGER_MEETING])
    const [timeValue, setTimeValue] = useState(() => {
        return {
            start: moment(), 
        }
    })
    const [focusInput, setFocusInput] = useState('')

    const handleOpenDatepickerCC = () => {
        inputDatePickerCCRef.current?.ref?.focus()
    }

    const handleHide = (event, picker) => {
        if(moment(timeValue.start).diff(moment(picker.startDate._d), 'day') !== 0) {
            dispatch(updateCurrentDay(picker.startDate._d))
            handleChangeTimeInCalendar(CALENDAR_VIEW.TIME_GRID_DAY, '', moment(picker.startDate._d).unix() * 1000, moment(picker.endDate._d).unix() * 1000)
            setDiffTime((prev) => {
                return {
                    ...prev,
                    diff: Math.round(moment(picker.startDate._d).diff(prev.current, 'day'))
                }
            })
            setTimeValue({
                start: moment(picker.startDate._d)
            })
        }
        setFocusInput('')
    };

    const handleFocusInput = () => {
        setFocusInput("daterange-container-focus")
    }

    useEffect(() => {
        if (inputDatePickerCCRef.current) {
            inputDatePickerCCRef.current.setStartDate(dayjs(currentDay).toDate())
            inputDatePickerCCRef.current.setEndDate(dayjs(currentDay).toDate())
            inputDatePickerCCRef.current.ref.value = dayjs(currentDay).format('DD/MM/YYYY')
        }
    }, [currentDay])

    return (
        <Box className={`${focusInput} daterange-container`} sx={{ borderRadius: 1.5,  width:'275px',  border: '1px solid #AAA', backgroundColor: color.white, p: '1px 4px 1px 9px', display: 'flex', alignItems: 'center' }}>
            <DateRangePicker
                sx={{width:'300px'}}
                ref={inputDatePickerCCRef}
                format = 'DD/MM/YYYY'
                initialSettings={{
                    singleDatePicker: true,
                    showDropdowns: true,
                    timePicker: false,
                    autoApply: true,
                    maxDate: maxDate,
                    startDate: moment().toDate(),
                    endDate: moment().toDate(),
                    locale: {
                        format: 'DD/MM/YYYY',
                        cancelLabel: t('filter.dateRange.cancel'),
                        applyLabel: t('filter.dateRange.apply'),
                        daysOfWeek: [
                            t('dateRangePicker.Su'),
                            t('dateRangePicker.Mo'),
                            t('dateRangePicker.Tu'),
                            t('dateRangePicker.We'),
                            t('dateRangePicker.Th'),
                            t('dateRangePicker.Fr'),
                            t('dateRangePicker.Sa'),
                        ],
                        monthNames: [
                            t('dateRangePicker.January'),
                            t('dateRangePicker.February'),
                            t('dateRangePicker.March'),
                            t('dateRangePicker.April'),
                            t('dateRangePicker.May'),
                            t('dateRangePicker.June'),
                            t('dateRangePicker.July'),
                            t('dateRangePicker.August'),
                            t('dateRangePicker.September'),
                            t('dateRangePicker.October'),
                            t('dateRangePicker.November'),
                            t('dateRangePicker.December'),
                        ],
                    },
                }}
                onHide={handleHide}>
                <input
                    format= 'DD/MM/YYYY'
                    type="text"
                    className='date-picker-cc'
                    id='date-picker-cc'
                    onClick={handleFocusInput}
                />
            </DateRangePicker>
            <IconButton sx={{ p: 0.5 }} onClick={handleOpenDatepickerCC}>
                <IconCalendarDatePicker />
            </IconButton>
        </Box>
    )
}

export default DatePickerCalenderCC